import {Component, Inject, OnInit} from '@angular/core';
import {GlobalConstants} from "../../../common/global-constants";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {ConfigurationService} from "../../../services/configuration.service";
import {validApprover} from "../../../services/validation.service";
import {AuthenticationService} from "../../../services/authentication.service";
import {CommonUtils} from "../../../utils/common.utils";

@Component({
  selector: 'app-update-transit-time-overrides',
  templateUrl: './update-transit-time-overrides.component.html',
  styleUrls: ['./update-transit-time-overrides.component.scss']
})

export class UpdateTransitTimeOverridesComponent implements OnInit {

  updateTransitTimeOverridesURL: string = GlobalConstants.PROCESS_TRANSIT_TIME_OVERRIDES_ENDPOINT;
  invokeTransitTimeOverridesWorkflowURL: string = GlobalConstants.INVOKE_TRANSIT_TIME_OVERRIDES_WORKFLOW_ENDPOINT;
  updateTransitTimeOverridesForm: FormGroup;

  updateOverridesTypeOptions: any = [];
  fromCountryCodeOptions: any = [];
  businessUseCases: any = [];

  transitTimeConfigurationRecords: any = [];
  selectedFile: File = null;
  loading = false;
  currentWorkingRecord: any;
  currentComponentKeyPlaceholder: any = [];

  single = GlobalConstants.SINGLE_KEYWORD;
  range = GlobalConstants.RANGE_KEYWORD;
  singleTransitTimeColumns: any = [];
  rangeTransitTimeColumns: any = [];

  help_messages: any = this.dataService.help_messages;

  dropDownOptions: any = {};
  items: any = {};

  user = {};

  get progress() {
    return this.uploadFileServiceUtils.progress;
  }

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('UploadFileServiceUtils') private uploadFileServiceUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService) {

  }


  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.updateTransitTimeOverridesForm = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyValue: ['', Validators.required],
      componentKeyPlaceholder: [''],
      updateOverridesType: ['', Validators.required],
      transitTimeOverridesFile: ['', Validators.required]
    });

    this.fromCountryCodeOptions = this.getFromCountryCodes();
    this.updateOverridesTypeOptions = this.dataService.updateOverridesTypeOptions;
    this.items = this.commonUtils.getItemsForTransitTimeOverrides();

  }

  onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};
    this.updateTransitTimeOverridesForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.updateTransitTimeOverridesForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue('');
    this.singleTransitTimeColumns = this.rangeTransitTimeColumns = this.currentComponentKeyPlaceholder = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.transitTimeConfigurationRecords = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  getFromCountryCodes() {
      return ["IN", "US", "CN", "BR"];
  }

  onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(this.currentWorkingRecord, this.transitTimeConfigurationRecords);

    this.updateTransitTimeOverridesForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER])
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.updateTransitTimeOverridesForm.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());

    let lookUpKeyColumns = this.commonUtils.generateLookUpKeyColumns(this.currentWorkingRecord);
    this.singleTransitTimeColumns = lookUpKeyColumns[GlobalConstants.SINGLE_TRANSIT_TIME_COLUMNS];
    this.rangeTransitTimeColumns = lookUpKeyColumns[GlobalConstants.RANGE_TRANSIT_TIME_COLUMNS];

    this.updateTransitTimeOverridesForm.get(GlobalConstants.UPDATE_TRANSIT_TIME_OVERRIDES_TYPE).setValue('');
    this.updateTransitTimeOverridesForm.get(GlobalConstants.TRANSIT_TIME_OVERRIDES_FILE).setValue('');

  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  onFileChange(event) {
    this.selectedFile = event.target.files[0];
  }

  public async submit() {
    // Creating Request Body
    var isWorkflowRunning;
    var message;
    this.requestsService.put(this.updateTransitTimeOverridesURL).subscribe(data => {
      this.loading = false;
      isWorkflowRunning = data[GlobalConstants.IS_WORKFLOW_RUNNING_RESPONSE_KEY];
      message = data[GlobalConstants.PROCESS_TRANSIT_TIME_OVERRIDES_RESPONSE_MESSAGE_KEY];
      if (isWorkflowRunning) {
        this.loading = false;
        this.toastrService.error(message, GlobalConstants.TITLE_ERROR);
      } else {
        this.uploadFileAndInvokeStepFunction();
      }
    }, error => {
      this.loading = false;
      console.log("Error");
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });


  }

  private async uploadFileAndInvokeStepFunction() {
    let requestBody = JSON.parse(JSON.stringify(this.updateTransitTimeOverridesForm.value));

    let overridesBucket = this.commonUtils.getOverridesBucket();
    requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    requestBody[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(requestBody[GlobalConstants.COMPONENT_KEY_VALUE], requestBody[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    let action = requestBody[GlobalConstants.UPDATE_TRANSIT_TIME_OVERRIDES_TYPE] == GlobalConstants.REMOVE_OVERRIDES ? GlobalConstants.REMOVE_OVERRIDES_ACTION : GlobalConstants.ADD_OVERRIDES_ACTION;

    let componentKeyValue = requestBody[GlobalConstants.COMPONENT_KEY_VALUE].replace(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR, GlobalConstants.SLASH);
    let folderName = requestBody[GlobalConstants.UPDATE_TRANSIT_TIME_OVERRIDES_TYPE] == GlobalConstants.REMOVE_OVERRIDES ? GlobalConstants.OVERRIDE_REMOVAL_FOLDER_NAME : GlobalConstants.UPLOADS_FOLDER_NAME;
    let key = folderName + GlobalConstants.SLASH + requestBody[GlobalConstants.BUSINESS_UNIT] + GlobalConstants.SLASH + requestBody[GlobalConstants.FROM_COUNTRY_CODE] + GlobalConstants.SLASH + componentKeyValue + GlobalConstants.SLASH + Math.round(Date.now() / 1000);
    requestBody[GlobalConstants.BUCKET] = overridesBucket;
    requestBody[GlobalConstants.KEY] = key;
    requestBody[GlobalConstants.ACTION] = action
    console.log(JSON.stringify(requestBody));

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions({
      ...requestBody,
      transitTimeType: "CARRIER_PROVIDED",
      createdBy: this.user[GlobalConstants.ALIAS],
      });
      this.loading = false;
      if (hasPermission === false){
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }

    let metadata = this.commonUtils.generateMetadata(requestBody);
    // File Upload and call backend apis
    let promise = (this.uploadFileServiceUtils.uploadFile(overridesBucket, key, this.selectedFile, metadata));
    await promise.then((data) => {
      this.toastrService.success(GlobalConstants.FILE_UPLOAD_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
      this.loading = true;
      this.requestsService.put(this.invokeTransitTimeOverridesWorkflowURL, requestBody).subscribe(data => {
        this.loading = false;
        this.toastrService.success(GlobalConstants.REQUEST_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
      }, error => {
        this.loading = false;
        this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
      });
    }).catch((data) => {
      this.toastrService.error(GlobalConstants.FILE_UPLOAD_FAILED, GlobalConstants.TITLE_ERROR);
      console.log(data)
    });
  }
}
